import { dynamic } from '../../../../external/dynamic';
import type { WithPartial } from '../../../../types';
import { InterfaceModes } from '../../../stores/InterfaceStore';
import type { InterfacePageProvidersProps } from './types';

const BuilderAndPreviewInterfacePageProviders = dynamic(
  () =>
    // eslint-disable-next-line import/no-cycle -- required for circular dependency
    import(
      /* webpackChunkName: "BuilderAndPreviewInterfacePageProviders" */
      './builder'
    ),

  // {
  //   loading: () => null,
  // },
);

const RunnerInterfacePageProviders = dynamic(
  () =>
    import(
      /* webpackChunkName: "RunnerInterfacePageProviders" */
      './runner'
    ),
  // Keeping it will add suspense boundary and ssr will fail
  // {
  //   loading: () => null,
  // },
);

export type Props = WithPartial<InterfacePageProvidersProps, 'mode'> & {
  disableInteractiveMode?: boolean;
  disableDevTools?: boolean;
};

export function InterfacePageProviders(props: Props) {
  const { mode = InterfaceModes.RUNNER } = props;

  return mode === InterfaceModes.RUNNER ? (
    <RunnerInterfacePageProviders {...props} mode={mode} />
  ) : (
    <BuilderAndPreviewInterfacePageProviders {...props} mode={mode} />
  );
}

export default InterfacePageProviders;
